export default [
	{
		tenantId: '3f5a9c8a-4a78-4723-a9bd-3f43b18fe5be',
		settings: {
			workflow: {
				professionalProfile: {
					hideRegistrationBodyField: true,
					hideRegistrationNumberField: true,
				},
				professionalCalendar: {
					eventColors: {
						applicationSent: 'yellow darken-1',
					},
				},
			},
			navigation: {
				hideTutorials: true,
			},
		},
	},
	{
		tenantId: '76081da2-5fdd-47b0-8caf-2c337ea3bf9f',
		settings: {
			workflow: {
				professionalProfile: {
					hideRegistrationBodyField: true,
					hideRegistrationNumberField: true,
				},
				professionalCalendar: {
					eventColors: {
						applicationSent: 'yellow darken-1',
					},
				},
			},
			navigation: {
				hideTutorials: true,
			},
		},
	},
];
